import React from 'react';
import { SearchSuggestionButtonProps } from '../search-suggestion.button.props';

import './search-suggestion-galleryItem.component.css';

interface SearchSuggestionGalleryProps extends SearchSuggestionButtonProps {
    readonly application: string;
    readonly imageUrl: string;
    readonly isPremium: boolean;
    readonly handleTemplateClick: (e: React.MouseEvent | React.KeyboardEvent) => void;
}

/*
 * Implementing a gallery item react component.
 */

export class SearchSuggestionGalleryItemComponent extends React.Component<SearchSuggestionGalleryProps> {

    public readonly handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.type === 'click') {
            e.preventDefault();
            e.currentTarget.blur();
            this.props.handleTemplateClick(e);
        }
    }

    public readonly handleKeyPress = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();
            this.props.handleTemplateClick(e);
        }
    }

    public render() {
        return (
            <a className={this.props.isPwa && this.props.isDarkMode ? 'gallery-item-container--darkMode' : 'gallery-item-container'}  role='option' data-nav='true' tabIndex={-1} onClick={e => this.handleClick(e)} onKeyPress={e => this.handleKeyPress(e)}>
                <div className='gallery-item-image-wrapper'>
                    <img src={this.props.imageUrl} className='gallery-item-image'/>
                </div>
                <div className='gallery-item-text'>
                    <div className={this.props.isPwa && this.props.isDarkMode ? 'gallery-item-text__title--darkMode' : 'gallery-item-text__title'}>
                        {this.props.isPremium && <div className={this.props.icon + ' gallery-item-icon'}></div>}{this.props.title}
                    </div>
                    <div className='gallery-item-text__application'>{this.props.application}</div>
                </div>
            </a>
        );
    }
}
